"use client";

import { c as _c } from "react/compiler-runtime";
import type { MarketplaceTypePreviewProps } from "./common";
import MarketplacePreview from "./MarketplacePreview";
export default function MarketplaceTransientMintPreview(t0) {
  const $ = _c(3);
  const {
    href,
    compact: t1
  } = t0;
  const compact = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== compact || $[1] !== href) {
    t2 = <MarketplacePreview href={href} compact={compact} />;
    $[0] = compact;
    $[1] = href;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}